import { marked } from "marked";
import sanitizeHtml from "sanitize-html";

// The editor's own placeholder lines, never shown on the site.
const PLACEHOLDERS = ["DELETE OR ADD DETAIL", "DELETE THIS SECTION OR ADD MORE DETAIL"];

// Tokyo's rich text editor (Quill) marks alignment with ql-align-* classes and
// offers underline and strike; keep those so what people set is what shows.
const ALIGN = ["ql-align-center", "ql-align-right", "ql-align-justify"];
const BLOCKS = ["h1", "h2", "h3", "h4", "h5", "h6", "p", "li", "blockquote"];

const RULES = {
    allowedTags: [...BLOCKS, "code", "pre", "ul", "ol", "b", "i", "em", "strong", "u", "s", "a", "br", "hr"],
    allowedAttributes: { a: ["href", "target", "rel"], code: ["class"] },
    allowedClasses: Object.fromEntries(BLOCKS.map((tag) => [tag, ALIGN])),
    allowedSchemes: ["http", "https", "mailto", "tel"],
};

// Words section text (markdown or the editor's HTML) -> safe HTML.
export function contentHtml(text) {
    if (typeof text !== "string" || !text.trim()) return "";
    let content = text;
    for (const p of PLACEHOLDERS) content = content.split(p).join("");
    return sanitizeHtml(marked(content), RULES);
}

// A Words block's HTML (already HTML, from the block editor) -> safe HTML,
// with the same rules as contentHtml but no markdown pass.
export function blockHtml(html) {
    if (typeof html !== "string" || !html.trim()) return "";
    let content = html;
    for (const p of PLACEHOLDERS) content = content.split(p).join("");
    return sanitizeHtml(content, RULES);
}
